import React from 'react';
import MainTemplate from 'pages/templates/MainTemplate';
import IpBlock from './IpBlock';

const AdverIpBlock = () => {
  return (
    <MainTemplate>
      <IpBlock />
    </MainTemplate>
  );
};

export default AdverIpBlock;
